<template>
  <div class="s-tabs-component">
    <div class="s-tabs-headers d-flex justify-space-between">
      <button
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{ 'active': tab.isActive }"
        class="s-tabs-headers__item"
        @click="selectTab(tab)"
      >
        {{ tab.name }}
      </button>
    </div>

    <div class="s-tabs-panels">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'STabs',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        tabs: [],
      }
    },
    created () {
      this.tabs = this.$children
    },
    methods: {
      selectTab (selectedTab) {
        if (this.disabled) {
          return
        }
        this.tabs.forEach(tab => {
          tab.isActive = (tab.name === selectedTab.name)
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.s-tabs-component {
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .s-tabs-headers {
    margin-bottom: 33px;
    border-bottom: 1px solid #d4d4d4;

    &__item {
      flex: 1;
      outline: none;
      font-size: 1.71em;
      line-height: 1.3;
      border-radius: 14px 14px 0 0;
      height: 2.65em;
      max-width: 50%;

      &.active {
        background-color: #191919;
        font-weight: 900;
        color: @color-primary;
      }
    }
  }
}

</style>
